import { InstructionAssignmentResponseDtoStatusEnum } from '@/types/Api';

export type InstructionDisplayStatus = 'OVERDUE' | 'SOON_DUE' | 'LATER';

const SOON_DUE_DAYS_THRESHOLD = 30;

export function getInstructionDisplayStatus(input: {
  status: InstructionAssignmentResponseDtoStatusEnum;
  dueDate: string;
}): InstructionDisplayStatus {
  if (input.status === InstructionAssignmentResponseDtoStatusEnum.OVERDUE) {
    return 'OVERDUE';
  }

  const daysUntilDue = Math.ceil(
    (new Date(input.dueDate).getTime() - new Date().setHours(0, 0, 0, 0)) / (1000 * 60 * 60 * 24),
  );

  return daysUntilDue <= SOON_DUE_DAYS_THRESHOLD ? 'SOON_DUE' : 'LATER';
}

export function getInstructionStatusLabelKey(status: InstructionDisplayStatus): string {
  if (status === 'OVERDUE') {
    return 'ohs-hub.instructions.status.overdue';
  }

  if (status === 'SOON_DUE') {
    return 'ohs-hub.instructions.status.soon_due';
  }

  return 'ohs-hub.instructions.status.later';
}
